import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';

import {MediaQuery} from '@constants/theme';

const DateCard = ({
  date,
  month,
}: {
  date: string;
  month: string;
}): JSX.Element => {
  return (
    <MuiBox
      sx={{
        paddingX: '20px',
        paddingBottom: '30px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'start',
        gap: '28px',
        whiteSpace: 'nowrap',
        [MediaQuery.mobile]: {
          padding: '30px',
          borderRadius: '24px',
        },
      }}>
      <MuiTypography
        sx={{
          marginLeft: '6px',
          textAlign: 'center',
          color: '#FFFFFF',
          fontWeight: 400,
          fontSize: '20px',
          letterSpacing: '-0.4px',
          [MediaQuery.mobile]: {
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '23.75px',
            letterSpacing: '-0.4px',
          },
        }}>
        {month?.length ? month : '-'}
      </MuiTypography>
      <MuiTypography
        sx={{
          fontWeight: 300,
          marginBottom: '15px',
          letterSpacing: '-0.4px',
          textAlign: 'center',
          color: '#FFFFFF',
          fontSize: '80px',
          lineHeight: '23.75px',
          [MediaQuery.mobile]: {
            fontWeight: 300,
            fontSize: '80px',
            lineHeight: '23.75px',
            letterSpacing: 0,
            textAlign: 'center',
          },
        }}>
        {date?.length ? date : '-'}
      </MuiTypography>
    </MuiBox>
  );
};

export default DateCard;
